// app/townlit-official/layout.tsx
"use client";

import React from "react";
import TownlitOfficialLayout from "../../components/layouts/TownlitOfficialLayout";

const Layout = ({ children }: { children: React.ReactNode }) => {
  const kids = React.Children.toArray(children);
  return <TownlitOfficialLayout>{kids}</TownlitOfficialLayout>;
};

export default Layout;
